import type { Lang } from "@iyk/vf-app-config"
import type { AudioPlayer } from "./AudioPlayer.ts"

import * as React from "react"

export const AudioPlayerContext = React.createContext<AudioPlayerContextValue | null>(null)

export interface AudioPlayerContextValue {
  currentTrack: AudioPlayer.CurrentTrack | null
  trackDuration: number
  trackIsPlaying: boolean
  trackIsBuffering: boolean
  trackIsReady: boolean
  getCurrentTrackTime: () => number
  playTrack: (trackId: string, playlist: AudioPlayer.Playlist) => void
  playPlaylist: (playlist: AudioPlayer.Playlist) => void
  playNextTrack: () => void
  playPreviousTrack: () => void
  togglePlayPause: () => void
  updateCurrentTrackTime: (time: number) => void
  reset: () => void
  lang: Lang
}
